/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

jQuery(function($){
    var win_wid = $(window).width();

    /* HEADER */
    var mob_menu = $('.mobile-menu');
    if ( mob_menu.length > 0 ) {
        var li = mob_menu.find('li'),
            has_child = li.find('.has_child'),
            menu_sub = li.find('.sub_menu');
        has_child.click(function(e){
            var this_par = $(this).parent(),
                this_sib = $(this).siblings('.sub_menu');
            e.preventDefault();

            this_par.toggleClass('show_sub');

            if ( this_par.hasClass('show_sub') ) {
                li.not(this_par).removeClass('show_sub');
                menu_sub.not(this_sib).slideUp();

                this_sib.slideDown();
            } else {
                this_sib.slideUp();
            }
        });
    }
    /* HEADER */

    /*--- FOOTER ---*/
    var footer_title = $('.footer_block_title'),
        footer_accord = $('.mob_accord_content');
    if ( footer_title.length > 0 ) {
        footer_title.click(function(){
            var sib_content = $(this).siblings('.mob_accord_content');

            $(this).toggleClass('active_footer');

            if ( $(this).hasClass('active_footer') ) {
                footer_title.not($(this)).removeClass('active_footer');
                footer_accord.not(sib_content).slideUp();

                sib_content.slideDown();
            } else {
                sib_content.slideUp();
            }
        });
    }
    /*--- FOOTER ---*/

    /*--- VIEW MORE ---*/
    var view_more = $('.view_more_section');
    if ( view_more.length > 0 ) {
        view_more.find('a').click(function(e){
            e.preventDefault();

            $(this).toggleClass('show');
            $(this).siblings('.desc').toggleClass('show');
        });
    }
    /*--- VIEW MORE ---*/
});